import React from 'react'

const CompanyRegistration = () => (
  <div>
    Deadly Byte Ltd is a registered company in England and Wales. Company No. 07486400. VAT No. 139180607.
  </div>
)

export default CompanyRegistration
